import { render, staticRenderFns } from "./LogsFormOld.vue?vue&type=template&id=4fa3ad38"
import script from "./LogsFormOld.vue?vue&type=script&lang=js"
export * from "./LogsFormOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports